import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import QuestionForm from "../../ui/QuestionForm/QuestionForm";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import { createQuestionAsync, clearQuestionForm } from "../../../redux/actions/editQuestion";
import { openCancelModal, closeCancelModal, getQuestionsCountAsync } from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.editQuestion,
  cancelModal: state.ui.cancelModal,
  countForClients: state.ui.countForClients,
  countForConsultants: state.ui.countForConsultants,
});

const mapDispatchToProps = dispatch => ({
  openCancelModal: () => dispatch(openCancelModal()),
  closeCancelModal: () => dispatch(closeCancelModal()),
  onGoBack: () => dispatch(push('/questions')),
  onCreateQuestion: () => dispatch(createQuestionAsync()),
  getQuestionsCount: () => dispatch(getQuestionsCountAsync()),
  clearForm: () => dispatch(clearQuestionForm()),
});

class CreateQuestion extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    question: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    cancelModal: PropTypes.object.isRequired,
    openCancelModal: PropTypes.func.isRequired, 
    closeCancelModal: PropTypes.func.isRequired,
    onCreateQuestion: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
    //Количество уже созданных вопросов разных типов
    getQuestionsCount: PropTypes.func.isRequired,
    countForClients: PropTypes.number.isRequired,
    countForConsultants: PropTypes.number.isRequired,
  };

  componentDidMount = () => {
    const { getQuestionsCount } = this.props;
    //Получение количества вопросов для клиентов и консультантов
    getQuestionsCount();
  }

  formIsEmpty = () => {
    const { question } = this.props;
    if ((question.header.length === 0) //Название вопроса не меняли
      && (question.answer.length === 0) //Ответ на вопрос не меняли
      && (!question.clients && !question.consultants) //Оба чекбокса не меняли
      && (question.children.length === 0) //Подвопросы не добавляли
    ) return true; 
    return false;
  }

  askOrGoBack = () => {
    const { question, openCancelModal, onGoBack } = this.props;
    this.formIsEmpty(question) ? onGoBack() : openCancelModal();
  }

  closeModalAndGo = () => {
    const { closeCancelModal, onGoBack, clearForm } = this.props;
    closeCancelModal();
    clearForm();
    onGoBack();
  }

  render() {
    const {
      ready,
      loading,
      question,
      cancelModal,
      closeCancelModal,
      onCreateQuestion,
      countForClients,
      countForConsultants
    } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
          confirmText="Остаться"
          cancelText="Покинуть страницу"
          modal={cancelModal}
          onSubmit={() => closeCancelModal()}
          onCancel={() => this.closeModalAndGo()}
        />
        <div className="page-header">
          {ready ? (
            <button type="button" className="btn btn-back" onClick={() => this.askOrGoBack()}>
              <i aria-hidden="true" className="back-icon icon" />
              <span>Назад</span> 
            </button>
          ) : false}
        </div>
        <div className="page-content forms">
          <div className="form-header">Создание вопроса</div>
          {ready ? (
            <QuestionForm
              question={question}
              countForClients={countForClients}
              countForConsultants={countForConsultants}
              submitText="Создать вопрос"
              onSubmit={() => onCreateQuestion()}
            />
          ) : false}
          {loading ? (<Spinner />) : false}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(CreateQuestion));
